import { z } from "zod";

/**
 * SEC-04: user-visible text may not contain control or invisible formatting
 * characters (newlines, NUL, bidi overrides). They enable header injection in
 * emails and visual spoofing (a right-to-left override that makes "evil[RLO]txt.exe" display as "evilexe.txt") in the UI.
 */
export const NO_CONTROL_CHARS = /^[^\p{Cc}\p{Cf}]*$/u;

export const safeText = (min: number, max: number) =>
  z
    .string()
    .trim()
    .min(min)
    .max(max)
    .regex(NO_CONTROL_CHARS, "Contains characters that aren't allowed");

/** A person's display name. */
export const personName = safeText(1, 100);

/** Profile images: https only (no javascript:, data: or http: URLs), bounded length. */
export const profileImageUrl = z
  .url({ protocol: /^https$/, hostname: z.regexes.domain })
  .max(2048)
  .nullable();

/**
 * Multi-line text (briefs, objectives, comments): line breaks and tabs are allowed,
 * every other control or invisible formatting character is not (SEC-04).
 */
const NO_CONTROL_CHARS_MULTILINE = /^(?:[^\p{Cc}\p{Cf}]|[\n\r\t])*$/u;

export const longText = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .regex(NO_CONTROL_CHARS_MULTILINE, "Contains characters that aren't allowed");
